module.exports = __webpack_public_path__ + "img/download.0de6d04f.svg";